import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useMutation, useNotify } from "ra-core";
import React from "react";
import { Booking } from "../../types";
import { OrderActions } from "./util";

interface Props {
  data: Booking;
}

const CancelNoUsageDialog: React.FC<Props> = ({ data }) => {
  const [open, setOpen] = React.useState(false);
  const notify = useNotify();
  const [mutate, { loading }] = useMutation();

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    mutate(
      {
        type: "update",
        resource: "bookings",
        payload: {
          id: data.id,
          data: {
            action: OrderActions.NO_USAGE,
          },
        },
      },
      {
        onSuccess: () => {
          notify("No usage cancellation processed.", "info");
          handleClose();
        },
        onFailure: (error: any) =>
          notify(
            `Error when updating the booking: ${error.message}`,
            "warning",
          ),
      },
    );
  };

  return (
    <>
      <Button
        color="secondary"
        onClick={handleClickOpen}
        size={"small"}
        variant="contained"
      >
        Cancel No Usage
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="cancel-no-usage-dialog-title"
        aria-describedby="cancel-no-usage-dialog-description"
      >
        <DialogTitle id="cancel-no-usage-dialog-title">
          Cancel No Usage?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-no-usage-dialog-description">
            Are you sure you want to cancel this no usage booking?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Back
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            disabled={loading}
            variant="contained"
          >
            {loading ? "Please wait..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelNoUsageDialog;
